<template>
    <ul class="flex flex-col items-stretch bg-bhav-cool-gray-50 rounded-md text-bhav-blue-500 cursor-default">
        <li class="px-3 py-2 gap-2 flex items-center justify-between relative group hover:bg-bhav-cool-gray-50 rounded-t-md">
            <span>{{ label }}</span><span class="far fa-chevron-down"></span>
            <ul class="absolute right-0 top-full bg-bhav-cool-gray-50 rounded-md rounded-tr-none shadow-lg
                   opacity-0 invisible group-hover:opacity-100 group-hover:visible
                   transition-opacity duration-300 transform scale-95 group-hover:scale-100
                   origin-top-left z-10 list-none p-0 m-0 overflow-hidden">
                <li v-for="(option, index) in options" :key="index"
                    class="cursor-pointer px-3 py-2 gap-2 whitespace-nowrap flex items-center justify-between hover:bg-bhav-blue-500 hover:text-white"
                    @click="option.click">
                    <span>{{ option.label }}</span>
                    <span v-if="option.icon" :class="option.icon"></span>
                </li>
            </ul>
        </li>
    </ul>
</template>

<script>
export default {
    name: 'Dropdown',
    props: {
        label: {
            type: String,
            default: 'Actions'
        },
        options: {
            type: Array,
            required: true,
            validator: (options) => {
                return options.every(option =>
                    option.hasOwnProperty('label') &&
                    option.hasOwnProperty('click')
                );
            }
        }
    }
}
</script>
